import { WatchFunnelService } from './../../../../services/watch-funnel.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IInbox, IFunnel } from '../../../../interfaces/graph-types';
import { FunnelService } from '../../../../services/funnel.service';

@Component({
  selector: '[account-funnel-inboxes]',
  template: require('./account-funnel-inboxes.component.pug'),
  styles: [require('./account-funnel-inboxes.component.css').toString()],
})
export class AccountFunnelInboxesComponent {
  private funnel_id: string = null;
  sub: any = null;

  funnel$: Observable<IFunnel> = null;

  // -------------------------------------------------------------------
  constructor(
    private watch_funnel: WatchFunnelService,
    private funnelService: FunnelService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit(): void {
    this.sub = this.watch_funnel.funnelId().subscribe(funnel_id => {
      this.funnel_id = funnel_id;
      this.funnel$ = this.funnelService.inboxes(this.funnel_id);
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  inboxClicked(
    inbox: IInbox,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.setFunnelInbox(
      this.funnel_id,
      inbox.id,
      !inbox.assigned,
      () => {
        inbox.assigned = !inbox.assigned;
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
